export default function MissionVision() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12">
          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-6">
              <i className="ri-compass-3-line text-3xl text-blue-600"></i>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h2>
            <p className="text-gray-600 leading-relaxed">
              To simplify global logistics by providing transparent, secure, and efficient 
              tracking solutions that empower businesses and individuals to ship with confidence 
              across all continents and transport modes.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-6">
              <i className="ri-eye-line text-3xl text-green-600"></i>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h2>
            <p className="text-gray-600 leading-relaxed">
              To become the world's most trusted logistics partner, connecting every corner 
              of the globe through innovative technology, sustainable practices, and 
              unparalleled customer service excellence.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-6">
              <i className="ri-heart-line text-3xl text-blue-600"></i>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Values</h2>
            <p className="text-gray-600 leading-relaxed">
              Transparency in every shipment, security in every transaction, innovation 
              in every solution, and sustainability in every decision. We put our customers 
              first and build lasting partnerships.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
